var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-image-preview',{attrs:{"images":_vm.images,"get-container":_vm.getContainer,"loop":_vm.loop,"start-position":_vm.startPosition,"close-on-popstate":false},on:{"change":_vm.onChange,"close":_vm.onClose},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }